/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


// setTimeout(function(){ jQuery.getJSON('/cart.js', function(cart) {
//     var total=cart.item_count;
// 	var freecount = $('span.cottonbagsNumber').html();
// //var profcount = $('.cart__quantity-field').val();
// var inputs = $(".cart__quantity-field");
// for(var i = 0; i < inputs.length; i++){
//     var newpro = $(inputs[i]).val();
// }
// var newcount = parseFloat(freecount) + parseFloat(newpro);
//  //if( isNaN(newcount))
//   if(isNaN(newcount)){
//     console.log("testnewcount")
//   }
// console.log(newcount);
//   if(newcount==0 || isNaN(newcount) ){
  
//   newcount=1;}
//   console.log("testsimple");
//   	$('span.header__cart__status').text(newcount);
//  var ff= $(".cottonbagsNumber").text();
//   if(ff==0){
//   $(".cottonbagsNumber").text(1);
//   }
// } ); 


// }, 3000);


$(document).ready(function(){
$(".product__content .form__wrapper .form__width input[name='id']").change(function(){
 setTimeout(function(){
  if($(".instock-div .variant__countdown").hasClass("count-is-out")){
   $(".instock-div").addClass("out-of-stock");
$(".product__submit__item button").attr("disabled","disabled");
  }else{
   $(".instock-div").removeClass("out-of-stock");
$(".product__submit__item button.btn.btn--primary.btn--solid").removeAttr("disabled");
$(".product__submit__item button.btn.btn--primary.btn--solid").prop("disabled", false);
  }
 },200);
});

$('.cart__foot__inner button.cart__checkout').click(function(){ 
   event.preventDefault();
  window.location.href = '/checkout'; 
  console.log("s");
}); 
  
})
$(".product__content .form__wrapper .form__width input[name='id']").change(function(){
 setTimeout(function(){
  if($(".instock-div .variant__countdown").hasClass("count-is-out")){
   $(".instock-div").addClass("out-of-stock");
$(".product__submit__item button").attr("disabled","disabled");
  }else{
   $(".instock-div").removeClass("out-of-stock");
$(".product__submit__item button.btn.btn--primary.btn--solid").removeAttr("disabled");
$(".product__submit__item button.btn.btn--primary.btn--solid").prop("disabled", false);
  }
 },200);
});



